import React from 'react';

import {
  AccordionButton,
  AccordionButtonContainer,
  AccordionContainer,
  AccordionContent,
  ChevronContainer,
} from './StyledComponents';
import { ChevronIcon } from '../Spots';

interface AccordionProps {
  alignButtonContent?: string;
  buttonContent: React.ReactNode;
  children: React.ReactNode | React.ReactNode[];
  fontSize?: string;
  isActive: boolean;
  onClick: () => void;
}

export const Accordion = ({
  alignButtonContent,
  buttonContent,
  children,
  fontSize,
  isActive,
  onClick,
}: AccordionProps): React.ReactElement => (
  <AccordionContainer isActive={isActive}>
    <AccordionButtonContainer alignButtonContent={alignButtonContent}>
      <AccordionButton fontSize={fontSize} onClick={onClick} type="button">
        {buttonContent}
        <ChevronContainer>
          <ChevronIcon isActive={isActive} />
        </ChevronContainer>
      </AccordionButton>
    </AccordionButtonContainer>
    {isActive && (
      <AccordionContent data-testid="accordion-content">
        {children}
      </AccordionContent>
    )}
  </AccordionContainer>
);
